import { render, staticRenderFns } from "./multiprojektsearch.vue?vue&type=template&id=43efd8b0&scoped=true"
import script from "./multiprojektsearch.vue?vue&type=script&lang=js"
export * from "./multiprojektsearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43efd8b0",
  null
  
)

/* custom blocks */
import block0 from "./multiprojektsearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports